/* agcac-run.js : AirGreen commercial AC page runtime. Renders the page template from state,
   replaces only the sections that changed. Pre-rendered HTML is already in the page for SEO. */
(function(){
  'use strict';
  function boot(){
    var A = window.AGCAC; var root = document.getElementById('agcac');
    if (!A || !root || root.getAttribute('data-booted')) return;
    root.setAttribute('data-booted', '1');
    function DCLogic(props){ this.props = props || {}; }
    DCLogic.prototype.setState = function(o){ var s = this.state; var n = typeof o === 'function' ? o(s) : o; for (var k in n) s[k] = n[k]; schedule(); };
    DCLogic.prototype.forceUpdate = function(){ schedule(); };
    var Component = A.mk(DCLogic);
    var inst = new Component(A.props || {});
    if (!inst.state) inst.state = {};
    var tpl = document.getElementById('agcac-tpl'); if (!tpl){ tpl = document.createElement('template'); tpl.innerHTML = A.tpl || ''; }
    var WHOLE = /^\s*\{\{([^}]+)\}\}\s*$/;
    function lookup(p, sc){ p = p.trim(); if (p === 'true') return true; if (p === 'false') return false; if (/^-?\d+(\.\d+)?$/.test(p)) return Number(p);
      var v = sc, ks = p.split('.'); for (var i = 0; i < ks.length; i++){ if (v == null) return undefined; v = v[ks[i]]; } return v; }
    function interp(s, sc){ return s.replace(/\{\{([^}]+)\}\}/g, function(m, p){ var v = lookup(p, sc); return v == null ? '' : String(v); }); }
    function proc(node, sc, out){
      var kids = node.childNodes;
      for (var i = 0; i < kids.length; i++){
        var ch = kids[i];
        if (ch.nodeType === 3){ out.push(document.createTextNode(interp(ch.nodeValue, sc))); continue; }
        if (ch.nodeType !== 1) continue;
        var tag = ch.localName;
        if (tag === 'sc-if'){ var m = (ch.getAttribute('value') || '').match(WHOLE); if (m && lookup(m[1], sc)) proc(ch, sc, out); continue; }
        if (tag === 'sc-for'){ var mf = ch.getAttribute('list').match(WHOLE); var L = mf ? lookup(mf[1], sc) : null; var as = ch.getAttribute('as');
          if (L && L.length){ for (var j = 0; j < L.length; j++){ var s2 = Object.create(sc); s2[as] = L[j]; s2.$index = j; proc(ch, s2, out); } } continue; }
        var el = document.createElementNS(ch.namespaceURI, ch.localName);
        var at = ch.attributes;
        for (var a = 0; a < at.length; a++){
          var name = at[a].name, val = at[a].value, mm = val.match(WHOLE);
          if (/^on[a-z]+$/.test(name) && mm){ var fn = lookup(mm[1], sc); var ev = name.slice(2);
            if (ev === 'change' && (el.localName === 'input' || el.localName === 'textarea')) ev = 'input';
            if (typeof fn === 'function') el.addEventListener(ev, fn); continue; }
          var v = mm ? lookup(mm[1], sc) : interp(val, sc);
          if (name === 'value' && (el.localName === 'input' || el.localName === 'textarea')){ el.value = v == null ? '' : v; el.setAttribute('value', v == null ? '' : v); continue; }
          el.setAttribute(name, v == null ? '' : String(v));
        }
        if (tag === 'textarea'){ var mt = (ch.getAttribute('value') || '').match(WHOLE); if (mt) el.textContent = lookup(mt[1], sc) || ''; }
        var sub = []; proc(ch, sc, sub); for (var b = 0; b < sub.length; b++) el.appendChild(sub[b]);
        out.push(el);
      }
    }
    var tops = []; var kids = tpl.content.childNodes;
    for (var i = 0; i < kids.length; i++){ var c = kids[i]; if (c.nodeType === 1 && c.localName === 'sc-if'){ var m = (c.getAttribute('value') || '').match(/vis\.s(\d+)/); if (m) tops.push({ n: m[1], node: c }); } }
    var last = {}, lastCtx = null;
    function render(){
      var vals; try { vals = inst.renderVals(); } catch(e){ if (window.console) console.error('agcac', e); return; }
      var act = document.activeElement, aid = act && root.contains(act) && act.id ? act.id : null, s0 = null, s1 = null;
      if (aid && typeof act.selectionStart === 'number'){ try { s0 = act.selectionStart; s1 = act.selectionEnd; } catch(e){} }
      for (var t = 0; t < tops.length; t++){
        var T = tops[t], box = root.querySelector('[data-sec="' + T.n + '"]');
        if (!box){ box = document.createElement('div'); box.setAttribute('data-sec', T.n); root.appendChild(box); }
        var out = []; proc(T.node, vals, out);
        var tmp = document.createElement('div'); for (var o = 0; o < out.length; o++) tmp.appendChild(out[o]);
        var html = tmp.innerHTML;
        if (last[T.n] === html) continue;
        last[T.n] = html;
        var keeps = tmp.querySelectorAll('[data-keep]');
        for (var q = 0; q < keeps.length; q++){ var k = keeps[q].getAttribute('data-keep'); var live = root.querySelector('[data-keep="' + k + '"]'); if (live) keeps[q].parentNode.replaceChild(live, keeps[q]); }
        while (box.firstChild) box.removeChild(box.firstChild);
        while (tmp.firstChild) box.appendChild(tmp.firstChild);
      }
      if (aid){ var f = document.getElementById(aid); if (f && f !== document.activeElement){ try { f.focus({ preventScroll: true }); if (s0 != null) f.setSelectionRange(s0, s1); } catch(e){} } }
      var ctx = vals.ctx || '';
      var hin = document.querySelector('[data-agcac-ctx]'); if (hin) hin.value = ctx;
      var line = document.querySelector('[data-agcac-ctxline]');
      if (line){ line.hidden = !ctx; var sp = line.querySelector('span'); if (sp) sp.textContent = ctx; }
      if (ctx && ctx !== lastCtx && lastCtx !== null){ var fc = document.getElementById('soumission'); if (fc) fc.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      lastCtx = ctx;
    }
    var queued = false;
    function schedule(){ if (queued) return; queued = true; (window.requestAnimationFrame || setTimeout)(function(){ queued = false; render(); }); }
    window.__agcacInst = inst;
    render();
    var clr = document.querySelector('[data-agcac-ctxclr]');
    if (clr) clr.addEventListener('click', function(){ inst.setState({ ctx: '' }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
